module.exports = __webpack_public_path__ + "img/cxTrends-12.35c30693.png";